import { memo } from 'react';

type TopListCardProps = {
  title: React.ReactNode;
  items: any[];
  label: (item: any, index: number) => string;
  value: (item: any) => string | number;
  accent: string;
  className?: string;
  empty: { icon?: React.ReactNode; title: string; description: string };
};

function TopListCardBase({
  title,
  items,
  label,
  value,
  accent,
  className = '',
  empty,
}: TopListCardProps) {
  return (
    <div
      className={`relative rounded-lg border border-[var(--anl-border)] bg-[var(--anl-metric-bg)] p-3 pb-4 ${className}`}
    >
      <div className="mb-2 text-xs font-medium text-[var(--anl-text-muted)]">{title}</div>
      {items.length > 0 ? (
        <ul className="space-y-1 text-[var(--anl-text)]">
          {items.map((it, index) => (
            <li key={index} className="flex justify-between text-xs">
              <span className="mr-2 truncate">{label(it, index)}</span>
              <span className="font-medium">{value(it)}</span>
            </li>
          ))}
        </ul>
      ) : (
        <div className="flex flex-col items-center justify-center py-4 text-gray-400">
          {empty.icon}
          <p className="text-center text-xs text-gray-500">{empty.title}</p>
          <p className="text-center text-xs text-gray-400">{empty.description}</p>
        </div>
      )}
      <div
        className="absolute bottom-0 left-0 right-0 rounded-b-lg"
        style={{ height: 6, backgroundColor: accent }}
      />
    </div>
  );
}

export const TopListCard = memo(TopListCardBase);
